import * as React from 'react';
import { Grid } from '@mui/material';
import './uploadImage.css';

interface UploadProps {
    name?: string;
    onChange?: (e: any) => void;
    label?: string;
    internalLabel?: string;
    accept?: string;
    error?: any;
    helperText?: string;
}

const UploadImage: React.FC<UploadProps> = ({
    name,
    onChange,
    accept
}) => (
    <React.Fragment>
       <Grid>
          <input
            id="uploadImage"
            type="file"
            className='hover:cursor-pointer absolute'
            name={name}
            accept={accept}
            onChange={onChange}
            onClick={(e: any) => {
                e.target.value = null;
            }}
            />
       </Grid>
    </React.Fragment>
);

export default UploadImage;
